var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #4c4c4c;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.3 31.98 13.17 32.2 13.03 37.19 9.12 37.06 9.3 31.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.72,13.52c.69-.2,3.08-.25,3.43.48.26.53.27,4.44-.12,4.71l-3.92-.13c-.05-1.1-.64-4.69.61-5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,27.93v-4.15c0-.07.32-.92.43-.95l3.73.27c.24.35.33,4.36-.28,4.84h-3.88Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.52,11.76c1.28-1.3,3.07-2.26,4.88-2.58,6.87-1.2,17.31-.96,24.29-.25,9.22.93,9.96,5.72,10.44,13.88.4,6.93.23,13.95,0,20.86-.22,6.51.89,16.39-7.55,18.15-5.7,1.19-14.01.86-19.86.56-8.42-.42-14.02-.44-15.02-10.44-.72-7.24-.68-16.08-.47-23.41.1-3.38.2-11.55,1.53-14.3.37-.77,1.18-1.87,1.77-2.47ZM37.59,17.7c-1.94.28-3.8,2.05-4.37,3.89-1.52,4.83,3.15,9.04,7.87,7.18,6.08-2.4,3.97-12.15-3.49-11.06ZM37.59,31.01c-3.45.38-7.29,2.97-8.79,6.12-1.16,2.43,0,4.95,2.56,5.72,3.77,1.15,11.33,1.23,15.06-.04,2.4-.81,3.45-3.41,2.36-5.68-1.88-3.94-6.86-6.6-11.19-6.12ZM31.6,48.45c-.98-.9-6.26-.95-6.92.62-1.4,3.35,4.13,3.38,6.08,2.87,1.55-.4,1.89-2.53.84-3.49ZM36.2,47.97c-2.41.6-2.33,3.7.2,4.06,2.79.39,11.57.35,14.43.02,2.98-.34,2.95-3.72.21-4.11-4.43-.63-10.26.38-14.84.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.0c3e75029d15e247f0c6616f522a4035.svg";
export { ForwardRef as ReactComponent };